import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-org-tree',
  standalone: true,
  imports: [],
  templateUrl: './org-tree.html',
  styleUrl: './org-tree.css',
})
export class OrgTreeComponent {
  @Input() orgTree: any[] = [];
  @Input() search: string = '';
  @Output() nodeSelectionChange = new EventEmitter<any>();
  @Output() orgTreeUpdated = new EventEmitter<void>();

  onNodeChecked(node: any, event: Event) {
    node.selected = (event.target as HTMLInputElement).checked;
    this.nodeSelectionChange.emit(node);
    this.orgTreeUpdated.emit();
  }

  filterTree(nodes: any[]): any[] {
    if (!this.search || this.search.trim() === '') {
      return nodes;
    }
    const searchLower = this.search.toLowerCase();
    return nodes
      .map(node => {
        const nameMatch = node.name && node.name.toLowerCase().includes(searchLower);
        let children = [];
        if (node.children && node.children.length) {
          children = this.filterTree(node.children);
        }
        if (nameMatch || children.length) {
          return { ...node, children };
        }
        return null;
      })
      .filter(node => node !== null);
  }
}
